import {notNullishAndPredicate} from '../../../shared/util/NotNullPredicate';
import {
	isInternalTimeRegistrationAllowed,
	isProjectTimeRegistrationAllowed,
} from '../../../shared/util/cache/TimeRegistrationSettingsUtil';
import {isTaskTimeRegistrationAllowed} from '../../../shared/util/time-registration/time-registration-settings/TimeRegistrationTaskFilter';
import {
	OldTimeRegistrationTargetSuggestion,
	OldTimeRegistrationTargetSuggestions,
	TimeRegistrationTargetSuggestion,
	TimeRegistrationTargetSuggestions,
	TimeRegistrationTargetSuggstionsData,
} from './TimeRegistrationTargetSuggestionsFetch';

const isSuggestionAllowed = (
	suggestion: TimeRegistrationTargetSuggestion | OldTimeRegistrationTargetSuggestion,
	selectedPersonId: string
): boolean => {
	if (!suggestion) return false;

	if ('project' in suggestion && suggestion?.project) {
		return isProjectTimeRegistrationAllowed();
	}
	if (suggestion?.idleTime) {
		return isInternalTimeRegistrationAllowed();
	}
	if (suggestion?.task) {
		const statusCategory = suggestion.task.statusColumnV2?.category;
		const assignedPersonIds = suggestion.task.assignedPersons
			? suggestion.task.assignedPersons.filter(notNullishAndPredicate()).map(person => person.id)
			: [];
		if (statusCategory) {
			return isTaskTimeRegistrationAllowed(statusCategory, selectedPersonId, assignedPersonIds, suggestion.task.project);
		}
	}
	return false;
};

export function getValidSuggestions(
	timeRegistrationTargetSuggestionsData: TimeRegistrationTargetSuggstionsData,
	selectedPersonId: string
): TimeRegistrationTargetSuggestions | OldTimeRegistrationTargetSuggestions {
	const newSuggestions = timeRegistrationTargetSuggestionsData?.timeRegistrationTargetSuggestions?.sortedSuggestions;
	if (newSuggestions && newSuggestions.length > 0) {
		return newSuggestions?.filter(suggestion => isSuggestionAllowed(suggestion, selectedPersonId)) ?? null;
	}

	// Fall back to old suggestions if new suggestions are null or empty
	const oldSuggestions = timeRegistrationTargetSuggestionsData?.oldTimeRegistrationTargetSuggestions;
	return oldSuggestions?.filter(suggestion => isSuggestionAllowed(suggestion, selectedPersonId)) ?? null;
}
